export const MAX_STARRED_REPORT_COUNT = 250;
